// src/components/profesional/EditarPerfilTelefono.tsx
import { useState } from 'react';
import { ButtonClose, ButtonSecundario } from '../../ui'; // Botones reutilizables
import { PopupTelefonos } from '../../popup'; // Popup para añadir teléfonos
import { EditarPerfilTelefonoProps, Telefono } from '@/types'; // Tipos de props y datos

// Componente para editar los teléfonos de un perfil
const EditarPerfilTelefono: React.FC<EditarPerfilTelefonoProps> = ({
  phones,           // Lista actual de teléfonos
  onPhoneChange     // Función callback para actualizar la lista de teléfonos
}) => {
  const [showPopup, setShowPopup] = useState(false); // Estado para mostrar u ocultar el popup

  // Función para añadir un nuevo teléfono
  const handlePhoneChange = (phone: Telefono) => {
    // Verifica si el teléfono ya existe
    const alreadyExists = phones.some(p => p.numero_telefono === phone.numero_telefono);

    if (alreadyExists) {
      alert(`Ya has añadido el teléfono ${phone.numero_telefono}.`); // Alerta si ya está añadido
      return;
    }

    // Limita el número de teléfonos a 2
    if (phones.length >= 2) {
      alert("Puedes agregar un máximo de 2 teléfonos.");
      return;
    }

    // Añade el nuevo teléfono a la lista
    const nuevosTelefonos = [
      ...phones,
      { telefono_id: undefined, numero_telefono: phone.numero_telefono }
    ];
    onPhoneChange(nuevosTelefonos); // Actualiza la lista en el estado del padre
    setShowPopup(false); // Cierra el popup
  };

  // Función para eliminar un teléfono por índice
  const handleRemovePhone = (index: number) => {
    const nuevos = phones.filter((_, i) => i !== index); // Filtra el teléfono seleccionado
    onPhoneChange(nuevos); // Actualiza la lista en el estado del padre
  };

  return (
    <div className="telefonos">
      {/* Botón para abrir el popup y añadir un teléfono */}
      <ButtonSecundario onClick={() => setShowPopup(true)}>
        Añadir Teléfono
      </ButtonSecundario>

      {/* Lista de teléfonos actuales */}
      <ul className="mt-2 grid xs:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-2 dark:text-zinc-900">
        {phones.map((phone, index) => (
          <li
            key={index}
            className="border border-blue-600 rounded-md pl-1 flex justify-between items-center"
          >
            {/* Muestra el número de teléfono */}
            <span className="text-start">{phone.numero_telefono}</span>

            {/* Botón para eliminar el teléfono */}
            <ButtonClose onClick={() => handleRemovePhone(index)} className="pr-1" />
          </li>
        ))}
      </ul>

      {/* Popup para añadir un nuevo teléfono */}
      {showPopup && (
        <PopupTelefonos
          onClose={() => setShowPopup(false)} // Cierra el popup
          onAddPhone={handlePhoneChange}      // Callback para añadir el teléfono
        />
      )}
    </div>
  );
};

export default EditarPerfilTelefono;
